import * as React from 'react'
import PropTypes from 'prop-types'
import * as AdminClient from 'clients/admin'

Provider.propTypes = {
    children: PropTypes.element,
}

export function Provider({ children }) {
    const { data } = AdminClient.useUserInfo()

    return <AuthorizationContext.Provider value={data}>{children}</AuthorizationContext.Provider>
}

export function useAuthorization() {
    return React.useContext(AuthorizationContext)
}

export function useHasAuthority(name) {
    const userInfo = useAuthorization()

    if (userInfo?.ullr) {
        return true
    }

    return Boolean(userInfo?.authorities?.includes(name))
}

const AuthorizationContext = React.createContext()
